import {UseQueryResult} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {EquipmentOption, EquipmentOptionType} from '../../types'

import {useSettingsQuery} from '@settings/modules/common/providers'
import {useUrlParam} from '@settings/modules/routing'

export const useAssetOptionsQuery = (): UseQueryResult<EquipmentOption[]> => {
  const plantCode = useUrlParam('plantCode')
  const {t} = useTranslation()

  return useSettingsQuery('assets', [plantCode], {
    select: (assets) =>
      assets
        .map<EquipmentOption>(({id, name}) => ({
          id,
          label: name,
          type: EquipmentOptionType.asset
        }))
        .sort((current, next) => (current.label > next.label ? 1 : -1)),
    meta: {
      errorMessage: t('samplingPointsSettings.queries.fetchAssetsError')
    }
  })
}
